export default class ConfigManager {
  constructor(defaultConfig, trackerConfig) {
    this._config = this.overwriteTrackersConfig(defaultConfig, trackerConfig);
  }

  get config() {
    return this._config
  }

  overwriteTrackersConfig(sourceConfig, targetConfig) {
    if (sourceConfig && sourceConfig.trackers && Array.isArray(sourceConfig.trackers)) {
      sourceConfig.trackers.map((tracker) => Object.assign(tracker, targetConfig));
    }
    return sourceConfig;
  }
}